import { useCallback, useContext, useMemo } from 'react';

import { OutrightsCouponContext } from '../context';
import { type MarketBet } from '../interfaces';

import { useOutrightsCouponContext } from './useOutrightsCouponContext';

export const useBetslip = ({
  betId,
  betLocation,
  betName,
  betOdds,
  bookieCode,
  eventName,
  marketName,
}: {
  betId: number;
  betLocation?: string;
  betName?: string;
  betOdds?: MarketBet;
  bookieCode: string;
  eventName?: string;
  marketName?: string;
}) => {
  const store = useContext(OutrightsCouponContext);
  if (!store) throw new Error('Missing OutrightsCouponContext.Provider in the tree');

  const selectedBets = useOutrightsCouponContext(state => state.selectedBets);
  const addSelectedBet = useOutrightsCouponContext(state => state.addSelectedBet);
  const removeSelectedBet = useOutrightsCouponContext(state => state.removeSelectedBet);

  const isBookieBetSelected = useMemo(
    () => selectedBets.some(bet => bet.betId === betId && bet.bookieCode === bookieCode),
    [betId, selectedBets, bookieCode],
  );

  const toggleBetslipBet = useCallback(() => {
    try {
      window.bettingActions.addOrRemoveFromBetslip(
        [{ betId, selectedBookie: bookieCode }],
        [betId],
        bookieCode,
        betOdds?.bestOddsDecimal?.toString(),
        betName,
        betLocation,
        marketName,
        eventName,
      );
    } catch (e) {
      console.error('useBetslip.toggleBetslipBet', e);
    }

    isBookieBetSelected ? removeSelectedBet(betId) : addSelectedBet({ betId, bookieCode });
  }, [
    isBookieBetSelected,
    removeSelectedBet,
    betId,
    addSelectedBet,
    bookieCode,
    betOdds,
    betName,
    betLocation,
    marketName,
    eventName,
  ]);

  return { isBookieBetSelected, toggleBetslipBet };
};
